import { TreeNodeHLGTLevel } from "../Node/MeddraNode/ListEntity/TreeNodeHLGTLevel";
import { TreeNodeLLTLevel } from "../Node/MeddraNode/ListEntity/TreeNodeLLTLevel";
import { TreeNodeHLTLevel } from "../Node/MeddraNode/ListEntity/TreeNodeHLTLevel";
import { TreeNodePTLevel } from "../Node/MeddraNode/ListEntity/TreeNodePTLevel";
import { TreeNodeSOCLevel } from "../Node/MeddraNode/ListEntity/TreeNodeSOCLevel";
import { Section } from "./Section";
import { SOCQueryNode } from "../Node/MeddraNode/Query/SOCQueryNode";
import { HLGTQueryNode } from "../Node/MeddraNode/Query/HLGTQueryNode";
import { HLTQueryNode } from "../Node/MeddraNode/Query/HLTQueryNode";
import { PTQueryNode } from "../Node/MeddraNode/Query/PTQueryNode";
import { LLTQueryNode } from "../Node/MeddraNode/Query/LLTQueryNode";
import { SimpleSearchNode } from "../Node/SimpleSearchNode";
import { BaseNode } from "../Node/BaseNode";
import { MeddraService } from "../../service/meddra-service/meddra.service";
export class MeddraSection extends Section {

    treeView: BaseNode[] = [];
    selectedNode!: BaseNode;
    socTermsTreeNode = new TreeNodeSOCLevel(this.ioc, undefined, undefined);
    hlgtTermsTreeNode = new TreeNodeHLGTLevel(this.ioc, undefined, undefined);
    hltTermsTreeNode = new TreeNodeHLTLevel(this.ioc, undefined, undefined);
    ptTermsTreeNode = new TreeNodePTLevel(this.ioc, undefined, undefined);
    lltTermsTreeNode = new TreeNodeLLTLevel(this.ioc, undefined, undefined);

    override resetSection(): void {
        this.ioc!.get(MeddraService).resetVersion();
        this.cleanSection();
    }

    cleanSection(){
        this.socTermsTreeNode = new TreeNodeSOCLevel(this.ioc, undefined, undefined);
        this.hlgtTermsTreeNode = new TreeNodeHLGTLevel(this.ioc, undefined, undefined);
        this.hltTermsTreeNode = new TreeNodeHLTLevel(this.ioc, undefined, undefined);
        this.ptTermsTreeNode = new TreeNodePTLevel(this.ioc, undefined, undefined);
        this.lltTermsTreeNode = new TreeNodeLLTLevel(this.ioc, undefined, undefined);

        // Queries node
        let queryTreeNode = new SimpleSearchNode(this.ioc, [], "Queries");
        queryTreeNode.children?.push(new SOCQueryNode(this.ioc, this.socTermsTreeNode));
        queryTreeNode.children?.push(new HLGTQueryNode(this.ioc, this.hlgtTermsTreeNode));
        queryTreeNode.children?.push(new HLTQueryNode(this.ioc, this.hltTermsTreeNode));
        queryTreeNode.children?.push(new PTQueryNode(this.ioc, this.ptTermsTreeNode));
        queryTreeNode.children?.push(new LLTQueryNode(this.ioc, this.lltTermsTreeNode));


        this.treeView.splice(0, this.treeView.length); // force to clean structure if it has any nodes
        this.treeView.push(this.socTermsTreeNode);
        this.treeView.push(this.hlgtTermsTreeNode);
        this.treeView.push(this.hltTermsTreeNode);
        this.treeView.push(this.ptTermsTreeNode);
        this.treeView.push(this.lltTermsTreeNode);
        this.treeView.push(queryTreeNode);

        this.selectedNode = this.socTermsTreeNode; 
    }

}
